var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('v-icon',{staticStyle:{"width":"30%"}},[_vm._v(" info ")]),_c('div',[_vm._v(_vm._s(_vm.titre))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }